import React, { Component } from 'react';
import './home.scss';
import Button from "../../components/button";

export default class HomePage extends Component {

    createHeaderText = () => {
        return (<React.Fragment>
            <img src={require('../../images/Logo_white.svg')} alt="mascota" className="logo" />
            <h2>
                Find a pet
            </h2>
            <h3>
                The easiest and smarter way to find a pet.
            </h3>
        </React.Fragment>)
    }

    componentDidMount() {
        console.log(localStorage.getItem('user_email'))
        if (localStorage.getItem('user_email')) {
            this.props.history.push('/grid-view')
        }
    }

    render() {
        return (
            <div className={"homepage bg-image"}>
                {this.createHeaderText()}
                <Button text={"Sign in"} action={() => this.props.history.push('/sign-in')} />
                <Button text={"Create account"} action={() => this.props.history.push('/sign-up')} />
            </div>
        );

    }
}
